import MenuIcon from '@mui/icons-material/Menu';
import {
  AppBar,
  Box,
  IconButton,
  Toolbar,
  useMediaQuery,
  useTheme,
} from '@mui/material';

import logo from '@/assets/logo.png';
import { useUIStore } from '@/stores/uiStore';

import { UserMenu } from './UserMenu';

export function AppBarTop(): JSX.Element {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const toggleSidebar = useUIStore((s) => s.toggleSidebar);
  const toggleMobileDrawer = useUIStore((s) => s.toggleMobileDrawer);

  function handleMenuClick(): void {
    if (isMobile) toggleMobileDrawer();
    else toggleSidebar();
  }

  return (
    <AppBar
      position="fixed"
      color="default"
      elevation={0}
      sx={{
        zIndex: (t) => t.zIndex.drawer + 1,
        backgroundColor: 'background.paper',
        borderBottom: (t) => `1px solid ${t.palette.divider}`,
      }}
    >
      <Toolbar>
        <IconButton
          edge="start"
          onClick={handleMenuClick}
          sx={{ mr: 2, color: 'text.primary' }}
          aria-label="Abrir menú"
        >
          <MenuIcon />
        </IconButton>

        <Box
          component="img"
          src={logo}
          alt="Sistema DPV"
          sx={{
            height: 40,
            width: 'auto',
            mr: 2,
            display: { xs: 'none', sm: 'block' },
          }}
        />

        <Box sx={{ flexGrow: 1 }} />

        <UserMenu />
      </Toolbar>
    </AppBar>
  );
}
